import { Session } from '@ais-ui/auth';

export interface SearchAndRescueResponse {
  messages: {
    lat: number;
    lon: number;
    message: string;
  }[];
}

export const periodicCheck = async (
  session: Session,
): Promise<SearchAndRescueResponse> => {
  const response = await session.request('doPeriodicCheck', {
    serverUid: 'd4bd4710-1765-4476-8969-09ab9d0b676f',
  });

  return response;
};

export const checkSearchAndRescue = async (
  session: Session,
): Promise<SearchAndRescueResponse> => {
  return periodicCheck(session);
};
